import React, { useState, useEffect, useContext } from "react";
import Auth from "@xometry/auth-context";
import { NotFoundError } from "../../ErrorState";

const StaffOnly: React.FC = ({ children }) => {
  const [isUserStaff, setIsUserStaff] = useState(false);
  const { isStaff, user } = useContext(Auth);

  useEffect(() => {
    setIsUserStaff(isStaff());
  }, [user]);

  if (!isUserStaff) {
    return <NotFoundError />;
  }

  return <>{children}</>;
};

export default StaffOnly;
